import { format, parseISO } from 'date-fns';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class DwDateAdapter extends NgbDateAdapter<string> {
  private readonly SYSTEM_DATE_FORMAT: string = 'yyyy-MM-dd';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value != null) {
      const parsedDate = parseISO(value);
      return {
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth() + 1,
        day: parsedDate.getDate(),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (date != null && this.SYSTEM_DATE_FORMAT != null) {
      const formattedDate = new Date(date.year, date.month - 1, date.day);
      return format(formattedDate, this.SYSTEM_DATE_FORMAT);
    }
    return null;
  }
}
